// extracted by mini-css-extract-plugin
export var actionButton = "_99-1";
export var actionButtons = "_99-2";
export var actions = "_99-0";
export var aiUnread = "_99-10";
export var alignCenter = "_99-h";
export var backWrapper = "_99-3";
export var cellContainer = "_99-4";
export var checkboxContainer = "_99-5";
export var contentContainer = "_99-6";
export var contentHeader = "_99-8";
export var conversationsTableWrapper = "_99-s";
export var draftReplyBadgeContainer = "_99-m";
export var dropdownItem = "_99-b";
export var dropdownItemsContainer = "_99-a";
export var dropdownTitle = "_99-c";
export var errorIcon = "_99-7";
export var filter = "_99-d";
export var gray = "_99-i";
export var headerActionButtons = "_99-e";
export var headerCheckboxContainer = "_99-f";
export var icon = "_99-j";
export var menuContainer = "_99-k";
export var noMoreTicketsIcon = "_99-12";
export var noMoreTicketsSubText = "_99-13";
export var oneLine = "_99-l";
export var optionsButton = "_99-n";
export var plus = "_99-o";
export var portalButtonsWrapper = "_99-g";
export var red = "_99-p";
export var scrolledTop = "_99-9";
export var search = "_99-q";
export var selectedConversationsCount = "_99-r";
export var spinner = "_99-t";
export var strong = "_99-u";
export var summaryCell = "_99-v";
export var tableContainer = "_99-11";
export var tagContainer = "_99-w";
export var threeDots = "_99-x";
export var twoLines = "_99-y";
export var unread = "_99-z";